import { RouteObject } from 'react-router-dom';
import ExploreDive from './pages/explore-dive/ExploreDive';

const ExploreRoutes: RouteObject = {
    path: 'explore/:id',
    element: <ExploreDive />,
};

export default ExploreRoutes;
